import * as types from './action-types';

import { defineAction } from 'store/common/action-helpers';

export const fetchTeamMembership = {
  request: ({ prettyId, teamMembershipId }) =>
    defineAction(types.FETCH_TEAM_MEMBERSHIP.REQUEST, { prettyId, teamMembershipId }),
  start: ({ prettyId, teamMembershipId }) =>
    defineAction(types.FETCH_TEAM_MEMBERSHIP.START, { prettyId, teamMembershipId }),
  success: ({ prettyId, teamMembershipId }) =>
    defineAction(types.FETCH_TEAM_MEMBERSHIP.SUCCESS, { prettyId, teamMembershipId }),
  failure: ({ prettyId, teamMembershipId, error }) =>
    defineAction(types.FETCH_TEAM_MEMBERSHIP.FAILURE, {
      prettyId,
      teamMembershipId,
      error,
    }),
};

export const fetchUserTeamMemberships = {
  request: ({ userId }) =>
    defineAction(types.FETCH_TEAM_MEMBERSHIPS_BY_USER_ID.REQUEST, { userId }),
  start: ({ userId }) => defineAction(types.FETCH_TEAM_MEMBERSHIPS_BY_USER_ID.START, { userId }),
  success: ({ teamMemberships, userId }) =>
    defineAction(types.FETCH_TEAM_MEMBERSHIPS_BY_USER_ID.SUCCESS, { teamMemberships, userId }),
  failure: ({ userId, error }) =>
    defineAction(types.FETCH_TEAM_MEMBERSHIPS_BY_USER_ID.FAILURE, { userId, error }),
};

export const pollCurrentUserTeamMembership = {
  start: ({ prettyId, teamMembershipId }) =>
    defineAction(types.POLL_TEAM_MEMBERSHIP.START, { prettyId, teamMembershipId }),
  stop: ({ prettyId, teamMembershipId }) =>
    defineAction(types.POLL_TEAM_MEMBERSHIP.STOP, { prettyId, teamMembershipId }),
};

export const showAcceptTeamMembershipInstuctions = ({ prettyId, teamMembershipId }) =>
  defineAction(types.SHOW_ACCEPT_TEAM_MEMBERSHIP_INSTRUCTIONS, { prettyId, teamMembershipId });

export const checkAcceptTeamMembershipStatus = {
  request: ({ prettyId, teamMembershipId }) =>
    defineAction(types.CHECK_ACCEPT_TEAM_MEMBERSHIP_STATUS.REQUEST, { prettyId, teamMembershipId }),
  start: ({ prettyId, teamMembershipId }) =>
    defineAction(types.CHECK_ACCEPT_TEAM_MEMBERSHIP_STATUS.START, { prettyId, teamMembershipId }),
  success: ({ prettyId, teamMembershipId }) =>
    defineAction(types.CHECK_ACCEPT_TEAM_MEMBERSHIP_STATUS.SUCCESS, { prettyId, teamMembershipId }),
  failure: ({ error, prettyId, teamMembershipId }) =>
    defineAction(types.CHECK_ACCEPT_TEAM_MEMBERSHIP_STATUS.FAILURE, {
      prettyId,
      teamMembershipId,
      error,
    }),
};

export const acceptTeamMembership = {
  request: ({ teamMembershipId, txHash, form }) =>
    defineAction(types.ACCEPT_TEAM_MEMBERSHIP.REQUEST, { teamMembershipId, txHash }, { form }),
  start: ({ teamMembershipId, txHash }) =>
    defineAction(types.ACCEPT_TEAM_MEMBERSHIP.START, { teamMembershipId, txHash }),
  success: ({ teamMembershipId, txHash }) =>
    defineAction(types.ACCEPT_TEAM_MEMBERSHIP.SUCCESS, { teamMembershipId, txHash }),
  failure: ({ error, teamMembershipId, txHash }) =>
    defineAction(types.ACCEPT_TEAM_MEMBERSHIP.FAILURE, { teamMembershipId, txHash, error }),
};

export const rejectTeamMembership = {
  request: ({ teamMembershipId }) =>
    defineAction(types.REJECT_TEAM_MEMBERSHIP.REQUEST, { teamMembershipId }),
  start: ({ teamMembershipId }) =>
    defineAction(types.REJECT_TEAM_MEMBERSHIP.START, { teamMembershipId }),
  success: ({ teamMembershipId }) =>
    defineAction(types.REJECT_TEAM_MEMBERSHIP.SUCCESS, { teamMembershipId }),
  failure: ({ error, teamMembershipId }) =>
    defineAction(types.REJECT_TEAM_MEMBERSHIP.FAILURE, { teamMembershipId, error }),
};

export const showRevokeTeamMembershipInstructions = ({ teamMembershipId }) =>
  defineAction(types.SHOW_REVOKE_TEAM_MEMBERSHIP_INSTRUCTIONS, { teamMembershipId });

export const revokeTeamMembership = {
  request: ({ teamMembershipId, txHash, form }) =>
    defineAction(types.REVOKE_TEAM_MEMBERSHIP.REQUEST, { teamMembershipId, txHash }, { form }),
  start: ({ teamMembershipId, txHash }) =>
    defineAction(types.REVOKE_TEAM_MEMBERSHIP.START, { teamMembershipId, txHash }),
  success: ({ teamMembershipId, txHash }) =>
    defineAction(types.REVOKE_TEAM_MEMBERSHIP.SUCCESS, { teamMembershipId, txHash }),
  failure: ({ error, teamMembershipId, txHash }) =>
    defineAction(types.REVOKE_TEAM_MEMBERSHIP.FAILURE, { teamMembershipId, txHash, error }),
};



// WEBPACK FOOTER //
// ./src/store/features/users/team-memberships/actions.js